enum InterestCalculatedOnBalanceType {
    AverageDailyBalance = "AVERAGE_BALANCE",
    MinimumBalance = "MINIMUM_BALANCE",
    EndOfDayBalance = "END_OF_DAY_BALANCE"
}
export default InterestCalculatedOnBalanceType